import { Grid } from '@mui/material'
import React from 'react'
import { ChartType, CustomTrace } from '../../shared/utils/chartModel'
import { RemoveIconButton } from '@e3dc-react/shell/Elements/Buttons'
import { ChartProps } from '../../shared/components/Chart'
import { TraceKey } from 'src/Libs/system-charts/shared/config/traceConf'
import LegendItem from '../../shared/components/LegendItem'

export interface CurrentTracesProps {
  chartType: ChartType
  currentTraces: CustomTrace[]
  setCurrentTraces: React.Dispatch<React.SetStateAction<CustomTrace[]>>
  chartProps?: ChartProps
  handlePopoverOpen: (traceKey: TraceKey, event?: React.MouseEvent<Element, MouseEvent>) => void
}

const getTraceKey = (trace: CustomTrace): string => trace.alternateKey ?? trace.key

const CurrentTraces: React.FC<CurrentTracesProps> = ({ chartType, currentTraces, setCurrentTraces, chartProps, handlePopoverOpen }) => {
  const handleRemoveTrace = (trace: CustomTrace): void => {
    const traceKey = getTraceKey(trace)
    setCurrentTraces(traces => traces.filter(traceToFind => getTraceKey(traceToFind) !== traceKey))
  }

  return (
    <>
      {currentTraces
        .filter(trace => !trace.sumKeys)
        .map(trace => {
          const traceKey = getTraceKey(trace)
          const chartTypeIconType = chartType === 'bar' ? 'bar' : 'line'
          const legendIconType = traceKey === 'ASOC' ? 'gradient' : chartTypeIconType

          return (
            <Grid key={traceKey} container>
              <Grid item xs={chartProps?.isInitial ? 12 : 8}>
                <LegendItem
                  key={traceKey}
                  type={legendIconType}
                  color={trace.color ?? ''}
                  title={trace.name ? trace.name : chartProps?.traceNames[traceKey] ?? ''}
                  onClick={e => handlePopoverOpen(traceKey as TraceKey, e)}
                />
              </Grid>
              {!chartProps?.isInitial && (
                <Grid item xs={2}>
                  <RemoveIconButton onClick={() => handleRemoveTrace(trace)} />
                </Grid>
              )}
            </Grid>
          )
        })}
    </>
  )
}

export default CurrentTraces
